/**
 * conversations.type of meeting recordings (the in-person recorder) and genie
 * meetings (the notetaker). Both have named speakers instead of a customer and
 * a genie, and are left out of Inbox Views unless a view opts in.
 */
export const RECORDED_MEETING_TYPES = ["recording", "meeting"] as const;

/** conversations.type of a genie meeting; its metadata is MeetingConversationMetadata. */
export const MEETING_CONVERSATION_TYPE = "meeting";

export const isRecordedMeeting = (type?: string | null): boolean =>
  !!type && (RECORDED_MEETING_TYPES as readonly string[]).includes(type);
